module.exports = __webpack_public_path__ + "static/media/part-5-3.b725417e.webp";